module.exports = __webpack_public_path__ + "img/pexercises.7ee6b1ef.svg";